var _defs, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _g4, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trophy_icon_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 840",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Trophy_icon_svg__cls-1{fill:#006c78}.Trophy_icon_svg__cls-3{fill:#fd934f}.Trophy_icon_svg__cls-4{fill:#fed425}.Trophy_icon_svg__cls-7{fill:#2a848e}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Trophy_icon_svg__cls-7",
    x: 296.95,
    y: 564.77,
    width: 246.09,
    height: 125.22,
    rx: 28.5,
    ry: 28.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-1",
    d: "M514.55 697.99H325.46c-20.13 0-36.5-16.37-36.5-36.5v-68.22c0-20.13 16.37-36.5 36.5-36.5h189.09c20.13 0 36.5 16.37 36.5 36.5v68.22c0 20.13-16.37 36.5-36.5 36.5zM325.46 572.77c-11.3 0-20.5 9.2-20.5 20.5v68.22c0 11.3 9.2 20.5 20.5 20.5h189.09c11.3 0 20.5-9.2 20.5-20.5v-68.22c0-11.3-9.2-20.5-20.5-20.5H325.46z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 296.95,
    y: 517.27,
    width: 246.09,
    height: 125.22,
    rx: 28.5,
    ry: 28.5,
    fill: "#95c2c7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-7",
    d: "M514.55 650.49H325.46c-20.13 0-36.5-16.37-36.5-36.5v-68.22c0-20.13 16.37-36.5 36.5-36.5h189.09c20.13 0 36.5 16.37 36.5 36.5v68.22c0 20.13-16.37 36.5-36.5 36.5zM325.46 525.27c-11.3 0-20.5 9.2-20.5 20.5v68.22c0 11.3 9.2 20.5 20.5 20.5h189.09c11.3 0 20.5-9.2 20.5-20.5v-68.22c0-11.3-9.2-20.5-20.5-20.5H325.46z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "Trophy_icon_svg__cls-4",
    x: 373.47,
    y: 431.01,
    width: 93.05,
    height: 170.51,
    rx: 38,
    ry: 38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M428.53 609.52h-17.05c-25.36 0-46-20.64-46-46v-94.51c0-25.36 20.64-46 46-46h17.05c25.36 0 46 20.64 46 46v94.51c0 25.36-20.64 46-46 46zm-17.05-170.51c-16.54 0-30 13.46-30 30v94.51c0 16.54 13.46 30 30 30h17.05c16.54 0 30-13.46 30-30v-94.51c0-16.54-13.46-30-30-30h-17.05z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "Trophy_icon_svg__cls-3",
    x: 373.47,
    y: 431.01,
    width: 93.05,
    height: 170.51,
    rx: 38,
    ry: 38
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M428.53 609.52h-17.05c-25.36 0-46-20.64-46-46v-94.51c0-25.36 20.64-46 46-46h17.05c25.36 0 46 20.64 46 46v94.51c0 25.36-20.64 46-46 46zm-17.05-170.51c-16.54 0-30 13.46-30 30v94.51c0 16.54 13.46 30 30 30h17.05c16.54 0 30-13.46 30-30v-94.51c0-16.54-13.46-30-30-30h-17.05z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M187.78 276.04c-15.74 0-28.5 12.76-28.5 28.5v47.51c0 68.21 55.29 123.5 123.5 123.5h135.71V276.04H187.78zM385.24 442.3H282.78c-49.76 0-90.25-40.49-90.25-90.25v-42.76h192.71V442.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M418.49 483.56H282.78c-72.51 0-131.5-58.99-131.5-131.5v-47.51c0-20.13 16.37-36.5 36.5-36.5h230.71c4.42 0 8 3.58 8 8v199.51c0 4.42-3.58 8-8 8zM187.78 284.05c-11.3 0-20.5 9.2-20.5 20.5v47.51c0 63.69 51.81 115.5 115.5 115.5h127.71V284.05H187.78zm197.46 166.26H282.78c-54.17 0-98.25-44.08-98.25-98.25V309.3c0-4.42 3.58-8 8-8h192.71c4.42 0 8 3.58 8 8v133.01c0 4.42-3.58 8-8 8zM200.53 317.3v34.76c0 45.35 36.9 82.25 82.25 82.25h94.46V317.3H200.53z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M282.78 483.56c-72.51 0-131.5-58.99-131.5-131.5v-47.51c0-20.13 16.37-36.5 36.5-36.5 4.42 0 8 3.58 8 8s-3.58 8-8 8c-11.3 0-20.5 9.2-20.5 20.5v47.51c0 63.69 51.81 115.5 115.5 115.5 4.42 0 8 3.58 8 8s-3.58 8-8 8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M421.51 276.04v199.51h135.71c68.21 0 123.5-55.29 123.5-123.5v-47.51c0-15.74-12.76-28.5-28.5-28.5H421.51zm33.25 33.25h192.71v42.76c0 49.76-40.49 90.25-90.25 90.25H454.76V309.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M557.22 483.56H421.51c-4.42 0-8-3.58-8-8V276.05c0-4.42 3.58-8 8-8h230.71c20.13 0 36.5 16.37 36.5 36.5v47.51c0 72.51-58.99 131.5-131.5 131.5zm-127.71-16h127.71c63.69 0 115.5-51.81 115.5-115.5v-47.51c0-11.3-9.2-20.5-20.5-20.5H429.51v183.51zm127.71-17.25H454.76c-4.42 0-8-3.58-8-8V309.3c0-4.42 3.58-8 8-8h192.71c4.42 0 8 3.58 8 8v42.76c0 54.17-44.08 98.25-98.25 98.25zm-94.46-16h94.46c45.35 0 82.25-36.9 82.25-82.25V317.3H462.76v117.01z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M419.53 530.4c-93.8 0-170.55-76.75-170.55-170.55l.95-105.88h341.1l-.95 105.88c0 93.8-76.75 170.55-170.55 170.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M419.53 538.4c-47.5 0-92.29-18.62-126.11-52.44s-52.44-78.6-52.44-126.11l.95-105.96a8.002 8.002 0 018-7.93h341.1c2.13 0 4.18.85 5.68 2.37a8.015 8.015 0 012.32 5.7l-.95 105.88c0 47.43-18.62 92.22-52.44 126.04s-78.6 52.44-126.11 52.44zM257.86 261.97l-.88 97.96c0 43.16 16.96 83.93 47.76 114.72 30.8 30.8 71.56 47.76 114.79 47.76 43.23 0 84-16.96 114.79-47.76 30.8-30.79 47.76-71.56 47.76-114.79l.88-97.88h-325.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 191.36,
    width: 341.1,
    height: 125.22,
    rx: 62.61,
    ry: 62.61,
    fill: "#be7f4d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M527.94 324.58H312.06c-38.93 0-70.61-31.68-70.61-70.61s31.68-70.61 70.61-70.61h215.88c38.93 0 70.61 31.68 70.61 70.61s-31.68 70.61-70.61 70.61zM312.06 199.36c-30.11 0-54.61 24.5-54.61 54.61s24.5 54.61 54.61 54.61h215.88c30.11 0 54.61-24.5 54.61-54.61s-24.5-54.61-54.61-54.61H312.06z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-4",
    d: "M590.55 261.97c-4.42 0-8-3.58-8-8 0-30.11-24.5-54.61-54.61-54.61H312.06c-30.11 0-54.61 24.5-54.61 54.61 0 4.42-3.58 8-8 8s-8-3.58-8-8c0-38.93 31.68-70.61 70.61-70.61h215.88c38.93 0 70.61 31.68 70.61 70.61 0 4.42-3.58 8-8 8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    className: "Trophy_icon_svg__cls-4",
    x: 399.87,
    y: 353.49,
    width: 40.27,
    height: 115.84,
    rx: 20.13,
    ry: 20.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 477.33c-15.51 0-28.13-12.62-28.13-28.13v-75.58c0-15.51 12.62-28.13 28.13-28.13s28.13 12.62 28.13 28.13v75.58c0 15.51-12.62 28.13-28.13 28.13zm0-115.84c-6.69 0-12.13 5.44-12.13 12.13v75.58c0 6.69 5.44 12.13 12.13 12.13s12.13-5.44 12.13-12.13v-75.58c0-6.69-5.44-12.13-12.13-12.13z",
    fill: "#fff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-3",
    d: "M557.22 483.56c-4.42 0-8-3.58-8-8s3.58-8 8-8c63.69 0 115.5-51.81 115.5-115.5v-47.51c0-11.3-9.2-20.5-20.5-20.5-4.42 0-8-3.58-8-8s3.58-8 8-8c20.13 0 36.5 16.37 36.5 36.5v47.51c0 72.51-58.99 131.5-131.5 131.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Trophy_icon_svg__cls-1",
    d: "M481.1 650.49H358.9c-4.42 0-8-3.58-8-8s3.58-8 8-8h122.2c4.42 0 8 3.58 8 8s-3.58 8-8 8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default ForwardRef;